import { render, staticRenderFns } from "./eventList.vue?vue&type=template&id=ae305054&scoped=true&"
import script from "./eventList.vue?vue&type=script&lang=js&"
export * from "./eventList.vue?vue&type=script&lang=js&"
import style0 from "./eventList.vue?vue&type=style&index=0&id=ae305054&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae305054",
  null
  
)

export default component.exports